import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useLockedPeriods = () => {
  const { api } = useAuth();
  const [locked, setLocked] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/periods');
      setLocked(res.data.filter(p => p.status === 'reconciled'));
    } catch {
      setLocked([]);
    }
  }, [api]);

  useEffect(() => { refresh(); }, [refresh]);

  const lockedPeriodFor = useCallback((businessId, date) => {
    if (!businessId || !date) return null;
    const day = String(date).slice(0, 10);
    return locked.find(p => p.business_id === businessId && p.start_date <= day && p.end_date >= day) || null;
  }, [locked]);

  return { lockedPeriodFor, refreshLocks: refresh };
};
